<template>
  <div class="page-add">
    <div class="add-title">编辑音频</div>
    <el-form
      class="form"
      size="small"
      label-position="right"
      label-width="100px"
      :rules="rules"
      :model="videoForm"
      ref="videoForm"
    >
      <el-row>
        <el-col>
          <el-form-item
            class="scale"
            label="音频内容："
            prop="audioLink"
            required
          >
            <av-preview
              v-if="videoForm.audioLink"
              :src="videoForm.audioLink"
              type="audio"
              @duration="audioDuration"
              @delete="deleteAudio"
            >
            </av-preview>
            <template v-else>
              <upload
                v-show="!showProgress"
                type="audio"
                :path="'audio/audio'"
                v-model="videoForm.audios"
                @progress="audioProgress"
              />
              <div v-show="showProgress" class="progress">
                <el-progress
                  type="circle"
                  :percentage="progress.audioProgress"
                  :width="100"
                ></el-progress>
              </div>
            </template>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="音频集：" prop="audioSetId">
            <el-select
              class="form-select has-btn"
              v-model="videoForm.audioSetId"
              filterable
              placeholder="请选择所属音频集（输入名称以搜索）"
              :remote-method="searchAudioSet"
              @focus="searchAudioSet()"
            >
              <el-option
                v-for="item in audioSetData"
                :key="item.uuid"
                :label="item.audioSetName"
                :value="item.uuid"
              >
              </el-option>
            </el-select>
            <el-button
              v-permission="'audioSet:save'"
              class="button-dept"
              @click="$router.push('/audioSet/edit')"
              >新增音频集</el-button
            >
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="音频名称：" prop="audioName" required>
            <el-input
              v-model="videoForm.audioName"
              placeholder="请输入音频名称"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="scale" label="音频封面：">
            <av-preview
              v-if="videoForm.coverUrl"
              :src="videoForm.coverUrl"
              type="image"
              @delete="deleteCover"
            />
            <upload
              v-else
              :draggable="false"
              :path="'audio/img'"
              type="image"
              v-model="videoForm.covers"
            />
            <span class="img_tip">建议尺寸：300px*300px（或1:1）</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="form-handle" label-width="0">
            <div class="center-view">
              <el-button @click="resetForm">重置</el-button>
              <el-button type="primary" @click="submit">提交</el-button>
              <back-button :pathOptions="pathOptions" :floatLeft="false" />
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { getAudioInfo, editAudio } from "@/api/audio";
import videoForm from "@/mixins/audio-form";
import Upload from "@/components/upload/index";
import AvPreview from "@/components/av-preview/index";
import { setItem } from "@/utils/storage.js";
import BackButton from "@/components/backButton/index.vue";

export default {
  name: "audioEdit",
  mixins: [videoForm],
  components: { Upload, AvPreview, BackButton },
  data() {
    return {
      pathOptions: {
        path: "/audio",
      },
    };
  },
  created() {
    this.getMapAndDetail();
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === "audioSet/edit") {
      this.$store.commit("app/setKeepAlive", "audioEdit");
    } else {
      this.$store.commit("app/setNotKeepAlive", "audioEdit");
    }
    next();
  },
  methods: {
    deleteCover() {
      this.videoForm.coverUrl = "";
      this.videoForm.covers = [];
    },
    submit() {
      this.$refs["videoForm"].validate().then(() => {
        let params = { ...this.videoForm, uuid: this.$route.query.id };
        delete params.videos;
        delete params.covers;
        editAudio(params).then((res) => {
          if (!res || res.code != 0) return;
          setItem(this.REFRESH_FLAG, true);
          this.$message({
            message: "音频编辑成功！",
            type: "success",
          });
          this.$router.back();
        });
      });
    },
    async getMapAndDetail() {
      getAudioInfo(this.$route.query.id).then((res) => {
        if (!res || res.code != 0) return;
        const { data } = res;
        this.audioSetData = [
          {
            audioSetName: data.audioSetName,
            uuid: data.audioSetId,
          },
        ];
        this.videoForm = {
          audios: [{ url: data.audioLink }],
          audioSetId: data.audioSetId,
          audioName: data.audioName,
          audioLength: data.audioLength,
          categoryId: data.categoryId,
          audioSource: data.audioSource != null && data.audioSource.toString(),
          expireTime: data.expireTime,
          covers: [{ url: data.coverUrl }],
          coverUrl: data.coverUrl,
        };
      });
    },
  },
};
</script>

<style lang="scss" scoped>
$textColor: #51627d;
$textSize: 14px;
.form-select {
  width: 100%;
  &.has-btn {
    width: calc(100% - 110px);
  }
}
.button-dept {
  margin-left: 10px;
  width: 100px;
}
.progress {
  outline: none;
  border: 1px dashed #d9d9d9;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  width: 260px;
  height: 160px;
}
.center-view {
  text-align: center;
}
</style>
